import PayMethod from "../payMethods";
import PayOnlineMethods from '../../data/payOlnineMethods.json'
import '../../style/pages/payMethodPage.css'
import { useCallback, useContext, useEffect, useState } from "react";
import { action } from "../../context/action";
import { isOnline } from "../../funcs/isOnline";
import { switchh } from "../../context/switch";
import { collection } from "../../context/collect";
import { context } from "../../context/context";
import { intialData } from "../../context/initial";
import paymob from "../../docs/partners/paymob.jpg";
import zone from "../../docs/partners/light.png";
import Policy from "../policy";
import { Setting } from "../../context/settings";
import { useTranslation } from "react-i18next";
import { auth } from "../../context/auth";
import useSocket from "../../funcs/socket/socket";
import { recodeNow } from "../indexDB/indexDBStora";
import { CurrentTime } from "../../funcs/current";
import { config } from "../../context/config";
import { InvoiceOrder } from "../invoices/invoice";
import { dataa } from "../../context/data";

export default function PayMethodPage (props) {
    const { t } = useTranslation();
    const { fallbackDuartion, devKey } = useContext(config)
    const { user, ActivEmp } = useContext(auth);
    const { setEnablePayOnline, enablePayOnline, errorMessage } = useContext(action);
    const { loadingProcess, setEnableDelivery, setLoadingProcess } = useContext(switchh);
    const { urlIframe, setUrlIframe, client, setClient } = useContext(collection);
    const { setClientFlag } = useContext(context);
    const { intialClient, initResetPayOnline } = useContext(intialData);
    const { storeConfig, storeInvoice, storeSociety } = useContext(Setting);
    const { setPaymentStatus } = useContext(dataa);
    
    const [line, setLine] = useState(false);
    const [readPloicy, setReadPolicy] = useState(false);

    useEffect(() => {
        setLine(isOnline());
    } , [enablePayOnline])

    const reset = () => {
        setUrlIframe("");
        setEnablePayOnline(initResetPayOnline);
        setClient(intialClient)
    }
    const RecordClientData = () => {
        setEnableDelivery(true);
        setEnablePayOnline(false);
        setClientFlag("payOnline");
    }

    const newClient = () => {
        let isClient = false;
        if(client.client_name && client.address && client.phone_number) {
            isClient = true;
        }
        return isClient;
    }

    // 6da0438-da2d-400f-a9a8-d32a1d5e285e_69c4a8ea39edebf12f39324552214551: "dufyFDM3ycZFfyiIQWSB"
    // generate id consists of invoiceId and userId and it is integrate with socketId
    // structure => owner_id_dev_id
    const id = `${user.data[0].id}_${devKey}`;
    const socket = useSocket(id);

    const empInfo = {
        id: ActivEmp?.code || "",
        name: ActivEmp?.name || ""
    };

    const infoSystem = {
        branch: user?.work?.workName || "",
        storeNumber: user?.work?.store || "",
        posStorageId: storeConfig?.pos || ""
    }

    const handler = useCallback(async (payload) => {
    try {
        setLoadingProcess(true);
        setPaymentStatus(payload);
        if (payload?.status) {
            const invoice = payload?.message;

            if (invoice?.id) {
                if (storeConfig.workMode === "live")
                    await recodeNow(invoice, "invoices");

                const current = CurrentTime();

                const page = InvoiceOrder(
                    current,
                    invoice?.currency?.symbol,
                    storeSociety?.hotline,
                    invoice?.discount,
                    invoice?.total,
                    invoice?.client_data,
                    invoice?.order_number,
                    empInfo,
                    infoSystem,
                    storeInvoice,
                    props.isDesktop,
                    invoice?.data
                );

                if (page) {
                    let printed = false;

                    const afterPrintHandler = () => {
                        if (printed) return;
                        printed = true;

                        page.close();
                        window.location.reload();
                    };

                    page.onafterprint = afterPrintHandler;

                    setTimeout(afterPrintHandler, fallbackDuartion);
                }
            }
        } else {
            console.log("payment failed");
        }
    } catch (error) {
        console.error("err -> ", error);
    } finally {
        setLoadingProcess(false);
    }
    }, [storeSociety, empInfo, infoSystem, storeInvoice]);

    useEffect(() => {
        if (!socket) return;

        socket.on("paymentPayload", handler);

        return () => {
            socket.off("paymentPayload", handler);
        };
    }, [socket, handler]);

    useEffect(() => {
    if (props.isDesktop && urlIframe) {
        window.electronAPI.openExternalgatewayPayment(urlIframe);
    }
}, [props.isDesktop, urlIframe]);

    return (
    <div className="container-box pay-container fixed flex flex-center-center">
        <div className={`${urlIframe ? "box-iframe" : "box"} center`}>
        <button className="close" onClick={()=>reset()}>x</button>
        {!readPloicy ? 
            <>
                {line ?
                <>
                {loadingProcess ?
                    <div>
                        <p>{t("common:wait")}</p>
                    </div>
                    :
                    !urlIframe ?
                    <div>
                        <div>
                            <h2 className="titles">{t("common:paymentOnlineSec.paymentOnline")}</h2>
                            <p>{t("common:collabrate")}</p>
                            <div className="partner-paymob flex flex-center-center">
                                <img src={zone} width="50" alt="logo" />
                                <span>+</span>
                                <img src={paymob} width="50" alt="logo" />
                            </div>
                        </div>
                        {newClient() ?
                            <div>
                                <h4 className="titles line">{t("common:paymentOnlineSec.totalPay", { totalVisa: props.moneyVisa }) } {props.currency}</h4>
                                <h3 className="titles">{t("common:paymentOnlineSec.choosePaymentMeth")}</h3>
                                <div className="flex flex-center-center">
                                    {PayOnlineMethods.map((e, i)=>
                                        <PayMethod pos={devKey} currency={props.currency} policyStatus={storeConfig?.isAcceptPolicy} key={i} img={require(`../../docs/payMethod/${e.img}`)} title={t(`action:payOnline.method.${e.title}`)} active={e.isactive} mode={e.mode} />
                                    )}
                                </div>
                                <p className="error">{errorMessage}</p>
                            </div>
                            :
                            <div className="btn-2">
                                <p>{t("common:ReadPolices")}</p>
                                <button className={
                                    !storeConfig?.isAcceptPolicy ?
                                    "disabled-bg-v2"
                                    :
                                    "success-bg"
                                } disabled={!storeConfig?.isAcceptPolicy} onClick={()=>RecordClientData()}>{t("action:payOnline.recordClientFirst")}</button>
                                <button onClick={()=>setReadPolicy(true)} className="normal-bg">{t("action:payOnline.readPolices")}</button>
                            </div>
                        }
                    </div>
                    :
                    !props.isDesktop && (
                        <a href={urlIframe} target="_blank" rel="noopener noreferrer">
                            Open Payment Gateway
                        </a>
                    )
                }
                </>
                :
                <div>
                    <h2>🔴 {t("error:global.unconnection.head")}</h2>
                    <p>{t("error:global.unconnection.body")}</p>
                </div>
                }
            </>
            :
            <Policy status={setReadPolicy} />
        }
        </div>
    </div>
    )
}